import { render, staticRenderFns } from "./ColorCurrentsBanner.vue?vue&type=template&id=3b1f2237"
import script from "./ColorCurrentsBanner.vue?vue&type=script&lang=js"
export * from "./ColorCurrentsBanner.vue?vue&type=script&lang=js"
import style0 from "./ColorCurrentsBanner.vue?vue&type=style&index=0&id=3b1f2237&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports